import { useRef, useState, useEffect } from 'react';
import TextBoxControl from "../../../Controls/TextBoxControl"
import GridControl from "../../../Controls/GridControl"
import Accordion from 'react-bootstrap/Accordion';
import { 
	GetLocal,
	FetchService,
	Base64Type
} from "../../../Base/BaseControl";

export default function Index(props) {
	const [getServiceResult, setServiceResult] = useState(false);
	
    useEffect(() => {
        var inputValue = {
             session: GetLocal('OwnersSession')
        };
        FetchService("Owner/Residential/ReviewReport/ShowReviewDetail", inputValue, ShowReviewDetailSuccess);
    }, []);	
	
    const ShowReviewDetailSuccess = (ServiceResult) => {
		setServiceResult(ServiceResult);
    }		
	
    return (
        <div>												
			<Accordion>
			  <Accordion.Item eventKey="0">
				<Accordion.Header>اطلاعات اصلی</Accordion.Header>
				<Accordion.Body>
					<table className="table table-bordered table-striped" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
						<tbody>
							<tr>
								<td colspan="3" className="text-right"><b class="b1">مامور بازدید:</b> {getServiceResult.Visitor}</td>
								<td colspan="3" className="text-right"><b class="b1">تاریخ بازدید:</b> {getServiceResult.ViewDate}</td>
								<td colspan="3" className="text-right"><b class="b1">نوبت بازدید:</b> {getServiceResult.InspectionNumber}</td>
							</tr>
							<tr>
								<td colspan="3" className="text-right"><b class="b1"> نوع زمین: </b> {getServiceResult.LandUse}</td>
								<td colspan="3" className="text-right"><b class="b1">مرحله ساختمانی:  </b> {getServiceResult.BuildingUsage}</td>
								<td colspan="3" className="text-right"><b class="b1">نوع اسکلت: </b> {getServiceResult.BuildingStructure}</td>
							</tr>
							<tr>
								<td colspan="3" className="text-right"><b class="b1">مساحت زمین: </b> {getServiceResult.ParcelArea}</td>
								<td colspan="3" className="text-right"><b class="b1">تعداد طبقات زیر زمین: </b> {getServiceResult.BasementFloorCount}</td>
								<td colspan="3" className="text-right"><b class="b1">تعداد طبقات سایر: </b> {getServiceResult.FloorCount}</td>
							</tr>
							<tr>
								<td colspan="3" className="text-right"><b class="b1">وضعیت ساختمان: </b> {getServiceResult.BuildingStage}</td>
								{getServiceResult.IsDisplayableFirstReviewField && <td colspan="3" className="text-right"><b class="b1">{getServiceResult.FirstReviewTitle}: </b> {getServiceResult.FirstReviewValue}</td>}
								{getServiceResult.IsDisplayableSecondReviewField && <td colspan="3" className="text-right"><b class="b1">{getServiceResult.SecondReviewTitle}: </b> {getServiceResult.SecondReviewValue}</td>}
							</tr>
							<tr>
								{getServiceResult.IsDisplayableThirdReviewField && <td colspan="3" className="text-right"><b class="b1">{getServiceResult.ThirdReviewTitle}: </b> {getServiceResult.ThirdReviewValue}</td>}
								{getServiceResult.IsDisplayableFourthReviewField && <td colspan="3" className="text-right"><b class="b1">{getServiceResult.FourthReviewTitle}: </b> {getServiceResult.FourthReviewValue}</td>}
								<td colspan="3" className="text-right"><b class="b1">وضعیت خلاف: </b> {getServiceResult.ContradictionStatus ? 'دارد':'ندارد'}</td>
							</tr>
							<tr>
								<td colspan="3" className="text-right"><b class="b1">شماره آخرین پروانه: </b> {getServiceResult.LastConstructNumber}</td>
								<td colspan="3" className="text-right"><b class="b1">شماره آخرین عدم خلاف: </b> {getServiceResult.LastNonContradictionNumber}</td>
								<td colspan="3" className="text-right"><b class="b1">شماره آخرین پایانکار: </b> {getServiceResult.LastCompletionNumber}</td>
							</tr>
							<tr>
								<td colspan="3" className="text-right"><b class="b1">تاریخ آخرین پروانه: </b> {getServiceResult.LastConstructDate}</td>
								<td colspan="3" className="text-right"><b class="b1">تاریخ آخرین عدم خلاف: </b> {getServiceResult.LastNonContradictionDate}</td>
								<td colspan="3" className="text-right"><b class="b1">تاریخ آخرین پایان کار: </b> {getServiceResult.LastCompletionDate}</td>
							</tr>	
							<tr>
								<td colspan="3" className="text-right"><b class="b1">تاریخ ساخت بنا: </b> {getServiceResult.BuildingYear}</td>
								<td colspan="3" className="text-right"><b class="b1">مصالح ساختمانی: </b> {getServiceResult.BuildingMaterials}</td>
								<td colspan="3" className="text-right"><b class="b1">مهندس ناظر: </b> {getServiceResult.SupervisorEngineer}</td>
							</tr>		
							<tr>
								<td colspan="9" className="text-right"><b class="b1">  توضیحات یازدید:</b> <br/> {getServiceResult.ReviewDescription} </td>
							</tr>									
						</tbody>
					</table>
				</Accordion.Body>
			  </Accordion.Item>
			  <Accordion.Item eventKey="1">
				<Accordion.Header>اطلاعات جهت و ابعاد ملک</Accordion.Header>
				<Accordion.Body>
					<table className="table table-bordered table-striped" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
						<thead>
							<tr>
								<th colspan="1" className="text-center"><b class="b1">جهت</b></th>
								<th colspan="1" className="text-center"><b class="b1">طول ضلع</b></th>
								<th colspan="1" className="text-center"><b class="b1">حد</b></th>
								<th colspan="1" className="text-center"><b class="b1">عرض گذر</b></th>
								<th width="30%" colspan="1" className="text-center"><b class="b1">نام معبر</b></th>
								<th width="30%" colspan="1" className="text-center"><b class="b1">پخ و قوس</b></th>								
							</tr>
						</thead>					
						<tbody>
							{getServiceResult.DimentionDetailsInfoList && getServiceResult.DimentionDetailsInfoList.map((item)=>(
								<tr>
									<td colspan="1" className="text-center">{item.DimensionsSide}</td>
									<td colspan="1" className="text-center">{item.LengthSide}</td>
									<td colspan="1" className="text-center">{item.LimitTitle}</td>
									<td colspan="1" className="text-center">{item.CrossWidth}</td>
									<td colspan="1" className="text-center">{item.StreetName}</td>
									<td colspan="1" className="text-center">{item.Description}</td>
								</tr>
							))}		
						</tbody>
					</table>
				</Accordion.Body>
			  </Accordion.Item>
			  <Accordion.Item eventKey="2">
				<Accordion.Header>اطلاعات بناهای موجود و مجاز</Accordion.Header>
				<Accordion.Body className="responseTable">
					<p class="text-primary">وضع موجود:</p>
					<table className="table table-bordered table-striped" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
						<thead>
							<tr>
								<th colspan="3" className="text-center"><b class="b1">طبقه</b></th>
								<th colspan="3" className="text-center"><b class="b1">نوع استفاده اصلی</b></th>
								<th colspan="3" className="text-center"><b class="b1">نوع استفاده فرعی</b></th>
								<th colspan="3" className="text-center"><b class="b1">واحد</b></th>
								<th colspan="3" className="text-center"><b class="b1">مساحت</b></th>
								<th colspan="3" className="text-center"><b class="b1">تعداد دهانه</b></th>
								<th colspan="3" className="text-center"><b class="b1">طول دهانه</b></th>
								<th colspan="3" className="text-center"><b class="b1">ارتفاع دهانه</b></th>
							</tr>
						</thead>					
						<tbody>
							{getServiceResult.AllowedUsageInfoList && getServiceResult.AllowedUsageInfoList.map((item)=>(
								<tr>
									<td colspan="3" className="text-center">{item.FloorTitle}</td>
									<td colspan="3" className="text-center">{item.PrimaryUsedTitle}</td>
									<td colspan="3" className="text-center">{item.SecondaryUsedTitle}</td>
									<td colspan="3" className="text-center">{item.Unit}</td>
									<td colspan="3" className="text-center">{item.Area}</td>
									<td colspan="3" className="text-center">{item.EntryNumber}</td>
									<td colspan="3" className="text-center">{item.EntryLength}</td>
									<td colspan="3" className="text-center">{item.EntryHeight}</td>
								</tr>	
							))}				
						</tbody>
					</table>
					<br/>
					<p class="text-primary">وضع مجاز:</p>
					<table className="table table-bordered table-striped" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
						<thead>
							<tr>
								<th colspan="3" className="text-center"><b class="b1">طبقه</b></th>
								<th colspan="3" className="text-center"><b class="b1">نوع استفاده اصلی</b></th>
								<th colspan="3" className="text-center"><b class="b1">نوع استفاده فرعی</b></th>
								<th colspan="3" className="text-center"><b class="b1">واحد</b></th>
								<th colspan="3" className="text-center"><b class="b1">مساحت</b></th>
								<th colspan="3" className="text-center"><b class="b1">تعداد دهانه</b></th>
								<th colspan="3" className="text-center"><b class="b1">طول دهانه</b></th>
								<th colspan="3" className="text-center"><b class="b1">ارتفاع دهانه</b></th>
							</tr>
						</thead>					
						<tbody>
							{getServiceResult.ExistUsageInfoList && getServiceResult.ExistUsageInfoList.map((item)=>(
								<tr>
									<td colspan="3" className="text-center">{item.FloorTitle}</td>
									<td colspan="3" className="text-center">{item.PrimaryUsedTitle}</td>
									<td colspan="3" className="text-center">{item.SecondaryUsedTitle}</td>
									<td colspan="3" className="text-center">{item.Unit}</td>
									<td colspan="3" className="text-center">{item.Area}</td>
									<td colspan="3" className="text-center">{item.EntryNumber}</td>
									<td colspan="3" className="text-center">{item.EntryLength}</td>
									<td colspan="3" className="text-center">{item.EntryHeight}</td>
								</tr>	
							))}							
						</tbody>
					</table>
					<br/>
					<p class="text-primary">اختلاف وضع موجود و مجاز:</p>
					<table className="table table-bordered table-striped" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
						<thead>
							<tr>
								<th colspan="3" className="text-center"><b class="b1">ردیف</b></th>
								<th colspan="3" className="text-center"><b class="b1">طبقه</b></th>
								<th colspan="3" className="text-center"><b class="b1">نوع استفاده اصلی</b></th>
								<th colspan="3" className="text-center"><b class="b1">نوع استفاده فرعی</b></th>
								<th colspan="3" className="text-center"><b class="b1">واحد</b></th>
								<th colspan="3" className="text-center"><b class="b1">مساحت</b></th>
							</tr>
						</thead>					
						<tbody>
							{getServiceResult.DifferenceUsageInfoList && getServiceResult.DifferenceUsageInfoList.map((item)=>(
								<tr>
									<td colspan="3" className="text-center">{item.Row}</td>
									<td colspan="3" className="text-center">{item.FloorTitle}</td>
									<td colspan="3" className="text-center">{item.PrimaryUsedTitle}</td>
									<td colspan="3" className="text-center">{item.SecondaryUsedTitle}</td>
									<td colspan="3" className="text-center">{item.Unit}</td>
									<td dir="ltr" colspan="3" className="text-center">{item.Area}</td>									
								</tr>	
							))}					
						</tbody>
					</table>					
				</Accordion.Body>
			  </Accordion.Item>			  
			</Accordion>			
        </div>
    );
}
